import { Navigate } from 'react-router-dom';
import { PrivacyPolicy } from '.';
const routes = [
    {
        path: '/privacy-policy',
        element: <PrivacyPolicy />,
        title: 'Privacy & Policy'
    }
]

export default routes;